import { Omit } from '@40seas/entities/common';
import { RutterValidation } from './rutter-validation.entity';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateRutterValidationDto extends Omit(RutterValidation, [...BaseEntityFieldsArray, 'status']) {}
